import {
  CHANGE_PASSWORD,
  CHECK_PASSWORD_RULES,
  CREATE_ACCOUNT,
  FETCH_INITIAL_STATE,
  FORGOT_PASSWORD,
  fetchInitialState,
  LOGOUT,
  LOGOUT_RTK,
  login,
  REQUEST_ACCESS,
  REQUEST_LOGIN,
  receiveInitialState,
} from "@/components/access/ducks/Actions"
import {
  apiFetchInitialState,
  changePassword,
  checkPasswordRules,
  createAccount,
  forgotPassword,
  loginAPI,
  logoutApi,
  requestAccess,
} from "@/components/access/ducks/AJAX"
import { receiveEmailDrafts } from "@/components/email/admin/ducks/Actions"
import { encodeQueryString } from "@/components/helpers/URL"
import _history from "routing/history"

export default (store) => (next) => (originalAction) => {
  const action = originalAction
  const { dispatch } = store

  const receiveLoginSuccess = (cb) => (response) => {
    if (response.redirectUrl) {
      _history.push({
        pathname: response.redirectUrl,
        search: encodeQueryString({ email: response.email }),
      })
    } else {
      dispatch(login())
      dispatch(fetchInitialState())
    }
    if (cb) {
      cb()
    }
  }

  const receiveCreateAccountSuccess = (cb) => () => {
    dispatch(login())
    dispatch(fetchInitialState(true))
    if (cb) {
      cb()
    }
  }

  const receiveInitialStateSuccess = (newAccount) => (response) => {
    const { currentUser, currentConstituent } = response

    dispatch(receiveInitialState(response, newAccount))
    dispatch(receiveEmailDrafts(currentConstituent))
    window.zE(() => {
      zE.identify({
        name: `${currentUser.firstName} ${currentUser.lastName}`,
        email: currentUser.email,
      })
    })
  }

  const receiveInitialStateError = (response) => {
    if (response.responseJSON && response.responseJSON.code === "missing_current_user") {
      dispatch(LOGOUT_RTK())
    }
  }

  switch (action.type) {
    case LOGOUT:
      logoutApi()
      return next(action)

    case REQUEST_ACCESS:
      requestAccess(action.params, action.success, action.error)
      return next(action)

    case FETCH_INITIAL_STATE:
      apiFetchInitialState(
        receiveInitialStateSuccess(!!action.newAccount),
        receiveInitialStateError,
      )
      return next(action)

    case CREATE_ACCOUNT:
      createAccount(
        action.ticketId,
        action.firstPassword,
        action.secondPassword,
        receiveCreateAccountSuccess(action.success),
        action.error,
      )
      return next(action)

    case CHANGE_PASSWORD:
      changePassword(
        action.ticketId,
        action.firstPassword,
        action.secondPassword,
        receiveLoginSuccess(action.success),
        action.error,
      )
      return next(action)

    case REQUEST_LOGIN:
      void loginAPI(
        action.email,
        action.password,
        receiveLoginSuccess(action.success),
        action.error,
      )
      return next(action)

    case FORGOT_PASSWORD:
      forgotPassword(action.email, action.success, action.error)
      return next(action)

    case CHECK_PASSWORD_RULES:
      checkPasswordRules(action.password, action.success, action.error)
      return next(action)

    default:
      return next(action)
  }
}
